import {React, classNames, observer, useLocalStore, useEffect, Fragment, IDisposer, useAsObservableSource, observable} from '@api'
import {ReactiveBase} from '@appbaseio/reactivesearch'
import {Button} from '@blueprintjs/core'
import {FilterStore, LoadingIndicator, StoresInstanceContext, useStores, useVipLocalStore, VipLocalStore} from '@modules'
import {ConfiguredFilterGroups, OfflineItemsFilterGroup, ReactiveSearchFilters, SearchFilterGroup} from './internal'
import {LibraryItemConfigWrapper, StoresInstance} from '@stores'
import * as css from './CatalogFilters.css'
import {authStore} from '@utils/authUtils'

export const useFilterStore = () => {
  const {filter} = useStores()
  return filter
}

interface MyProps {
  className?: string,
  library?: LibraryItemConfigWrapper
}

/** No longer used - {@see CatalogItemsList.overrideStores} **/
// export class CatalogFiltersStore extends VipLocalStore {
//   constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
//     super(stores)
//
//     if (props.library) {
//       this.overrideStores = new StoresInstance(
//         `Library filters for - ${props.library?.id}`,
//         stores.workspaces.workspaceForLibrary(props.library),
//         `${stores._id}-Filters-${props.library?.id}}`,
//         'library-filters',
//         {library: props.library})
//     }
//     else {
//       this.overrideStores = stores
//     }
//   }
//
//   @observable.ref overrideStores: StoresInstance
//
//   registerEffects = () => {
//     const toDispose: Array<IDisposer> = []
//
//     return () => {
//       if (this.overrideStores !== this.stores) {
//         this.overrideStores.dispose()
//       }
//
//       toDispose.forEach(d => d())
//     }
//   }
// }

export const CatalogFilters = observer<MyProps>(function CatalogFilters({className, library}) {
    const stores = useStores(),
      {es: {clientUrl}, strings, filter, filter: {onTransformReactiveBaseSearchRequest}, catalog, config, catalog: {hasLoadedConfig, itemCount}} = stores,
      noSearchResults = filter.noSearchResults && filter.hasSearchText && !filter.loading && filter.hasLoaded

    return (
      <div className={classNames(css.root, className)}
           data-loaded={filter.hasLoaded}
           data-no-search-results={noSearchResults}
           data-type='filters'>
        {!hasLoadedConfig ? <LoadingIndicator/> :
         <ReactiveBase
           data-type='ReactiveBase'
           className={css.reactiveBase}
           app={catalog.index}
           headers={{
             authorization: authStore.accessToken
           }}
           url={clientUrl}
           transformRequest={onTransformReactiveBaseSearchRequest}
         >
           <Fragment>
             <div className={css.row}>
               <SearchFilterGroup className={css.search}>
                 <ClearFiltersButton/>
               </SearchFilterGroup>
             </div>

             <div className={classNames(css.remainingGroups)}>
               {false && <ReactiveSearchFilters/>}

               {!library && catalog.canCreateItem && <OfflineItemsFilterGroup/>}

               {/*{!filter.hasLoaded && <LoadingIndicator className={css.loading}/>}*/}
               <ConfiguredFilterGroups library={library}/>

               {noSearchResults && (itemCount === 0
                                    ? <div className={css.noSearchFilters} key='no-filters'>{strings.noFilterFound}</div>
                                    : <div className={css.noSearchFilters} key='no-search-filters'>{strings.noFiltersSearchFound}</div>)}
             </div>
           </Fragment>
         </ReactiveBase>}
      </div>
    )
  }
)

export const ClearFiltersButton = observer<{}>(function ClearFiltersButton() {
  const {strings, hasFilterTerms, library, resetFilters} = useFilterStore()
  return hasFilterTerms && library ? (
    <div className={css.clearFilters}>
      <Button text={strings.clearFilters} onClick={e => resetFilters(false)}/>
    </div>) : null
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/filters/components/CatalogFilters.tsx